import gql from "graphql-tag"
import type { TypedDocumentNode } from "@graphql-typed-document-node/core"

type OrderOperationEvent = {
  orderId: string
  type: string
}

type OnOrderOperationCreatedSubscription = { OnOrderOperationCreated: OrderOperationEvent }

const ON_ORDER_OPERATION_CREATED: TypedDocumentNode<
  OnOrderOperationCreatedSubscription,
  Record<string, never>
> = gql`
  subscription OnOrderOperationCreated {
    OnOrderOperationCreated {
      orderId
      type
    }
  }
`

export default ON_ORDER_OPERATION_CREATED
